<template>
  <div>
    <!-- title bar -->
    <nav class="navbar navbar-inverse">
      <div class="container-fluid">
        <p class="navbar-text navbar-left">APT Project <template v-if="!generalObj.IsLocked">Configuration</template> <template v-else>Preview</template></p>

        <div class="navbar-right navbar-form">
          <button class="btn btn-primary" :class="{'hide-on-preview':generalObj.IsLocked}" @click="saveProject">Save</button>

          <button
            class="btn btn-primary"
            @click="testProject"
            :disabled="projectID === 0"
          >
            Test
          </button>

          <router-link :to="`/?cipID=${this.cipID}`" activeClass="active" tag="a">
            <button class="btn btn-primary">Back</button>
          </router-link>
        </div>
      </div>
    </nav>

    <!-- GENERAL configure panel -->
    <div class="panel panel-info configurePanel" :class="{'configurePanel--preview':generalObj.IsLocked}">
      <div class="panel-heading">
        <h3 class="panel-title">General Configure</h3>
      </div>
      <div class="panel-body">
        <div>
          <div class="col-md-8">
            <label for="">Project Name </label>
            <input
              type="text"
              class="col-md-12"
              placeholder="eg: Expedia DBA"
              v-model="generalObj.projectName"
            />
          </div>
          <div class="col-md-2">
            <label for="">Exercise Type</label>
            <select v-model="generalObj.exerciseType">
              <option value="" selected disabled>Select exercist type</option>
              <option value="Ad Test">Ad Test</option>
              <option value="Brand / Ad Tracker">Brand / Ad Tracker</option>
              <option value="Brand Positioning">Brand Positioning</option>
              <option value="Claims / Positioning Test">
                Claims / Positioning Test
              </option>
              <option value="Concept Test">Concept Test</option>
              <option value="Distinctive Brand Asset">
                Distinctive Brand Asset
              </option>
              <option value="MarketSpex">MarketSpex</option>
              <option value="Name Test">Name Test</option>
              <option value="Pack Test">Pack Test</option>
              <option value="Shopper Based Design">Shopper Based Design</option>
              <option value="U&A">U&A</option>
            </select>
            <!-- <input type="text" class="col-md-12" v-model="generalObj.primeDuration"> -->
          </div>
          <div class="col-md-2">
            <label for="">Language</label>
            <select v-model="generalObj.language">
              <option value="" disabled>Select language</option>
              <option
              v-for="lang in sortedLanguages"
              :key="lang"
              :value="lang"
              >
              {{ lang }}
              </option>
            </select>
          </div>

        </div>
        <div>
          <div class="col-md-6">
            <label for=""
              >Prime Duration
              <small>(Duration for Displaying Prime)</small></label
            >

            <input
              type="text"
              class="col-md-12"
              v-model="generalObj.primeDuration"
              :disabled="!editableFieldsControl.primeDuration"
            />
            <div
              class="edit-field-icon"
              :class="{ 'is-disabled': editableFieldsControl.primeDuration }"
              @click="openConfirmationModal('Prime Duration', 'primeDuration')"
            >
              <div class="edit-field-icon__title">Edit field</div>
            </div>
          </div>
          <div class="col-md-6">
            <label for=""
              >Test Duration
              <small>(Duration for Displaying Stimulus)</small></label
            >

            <input
              type="text"
              class="col-md-12"
              v-model="generalObj.testDuration"
              :disabled="!editableFieldsControl.testDuration"
            />
            <div
              class="edit-field-icon"
              :class="{ 'is-disabled': editableFieldsControl.testDuration }"
              @click="openConfirmationModal('Test Duration', 'testDuration')"
            >
              <div class="edit-field-icon__title">Edit field</div>
            </div>
          </div>
        </div>
        <div>
          <div class="col-md-6">
            <label for=""
              >Feedback Duration
              <small>(Duration for Displaying Feedback Time)</small></label
            >

            <input
              type="text"
              class="col-md-12"
              v-model="generalObj.feedbackDuration"
              :disabled="!editableFieldsControl.feedbackDuration"
            />
            <div
              class="edit-field-icon"
              :class="{
                'is-disabled': editableFieldsControl.feedbackDuration,
              }"
              @click="
                openConfirmationModal('Feedback Duration', 'feedbackDuration')
              "
            >
              <div class="edit-field-icon__title">Edit field</div>
            </div>
          </div>
          <div class="col-md-6">
            <label for=""
              >Blank Interval
              <small>(Duration for stimulus's interval)</small></label
            >

            <input
              type="text"
              class="col-md-12"
              v-model="generalObj.blankInterval"
              :disabled="!editableFieldsControl.blankInterval"
            />
            <div
              class="edit-field-icon"
              :class="{ 'is-disabled': editableFieldsControl.blankInterval }"
              @click="openConfirmationModal('Blank Interval', 'blankInterval')"
            >
              <div class="edit-field-icon__title">Edit field</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Practice Target  panel -->
    <div class="panel panel-info configurePanel"  :class="{'configurePanel--preview':generalObj.IsLocked}">
      <div class="panel-heading">
        <h3 class="panel-title">Practice Round Configure</h3>
      </div>

      <div class="panel-body">
        <div class="col-md-4">
          <label for="">Practice Category 1</label>
          <input
            type="text"
            class="col-md-12"
            placeholder="eg: POSITIVE"
            v-model="principle.clientDesc"
          />
        </div>
        <div class="col-md-8">
          <label for="">Practice Attribute 1 </label>
          <textarea
            type="text"
            rows="1"
            class="col-md-12"
            placeholder="eg: Good"
            v-model="principle.clientURL"
          ></textarea>
        </div>
        <div class="col-md-4">
          <label for="">Practice Category 2</label>
          <input
            type="text"
            class="col-md-12"
            placeholder="eg: NEGATIVE"
            v-model="principle.competitiveDesc"
          />
        </div>
        <div class="col-md-8">
          <label for="">Practice Attribute 2</label>
          <textarea
            type="text"
            rows="1"
            class="col-md-12"
            placeholder="eg: Bad"
            v-model="principle.competitiveURL"
          ></textarea>
        </div>
      </div>
    </div>

    <!-- PRIME configure panel -->
    <div class="panel panel-info configurePanel"  :class="{'configurePanel--preview':generalObj.IsLocked}">
      <div class="panel-heading">
        <h3 class="panel-title">
          Prime (i.e. asset, brand name or logo, packaging)
        </h3>
        <div class="btnContainer">
          <button class="btn btn-primary btn-sm" :class="{'hide-on-preview':generalObj.IsLocked}" @click="addMoreAssets">
            Add More Assets
          </button>
          <!-- <button class="btn btn-primary btn-sm" @click="exportBrandMap">Export Mapping for RN</button>            -->
        </div>
      </div>

      <div class="panel-body">
        <div class="checkbox primeDouble">
          <label @click="toggleDoubleTime"
            ><input type="checkbox" v-model="generalObj.testBrand" />Double
            Prime Impression (for 4 attributes 3 primes test, the trial number
            will increase from 12 to 24)</label
          >
        </div>

        <div class="col-md-3">
          <label for="">Prime Assignment (awareness/familiarity)</label>
          <select v-model="primeAssignment">
            <option value="" selected disabled>Select Prime Assignment</option>
            <option value="No assignment, fell out naturally">No assignment, fell out naturally</option>
            <option value="Based on aware/familiar of assigned">Based on aware/familiar of assigned</option>
            <option value="Based on aware/familiar of all">Based on aware/familiar of all</option>
            <option value="Based on aware/familiar of some">Based on aware/familiar of some</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="col-md-4">
          <label for="">Pre-exposure Format Type:</label>
          <select v-model="preExposureFormatType">
            <option value="" selected disabled>Select Pre-exposure Format</option>
            <option value="None">None</option>
            <option value="Video">Video</option>
            <option value="Text">Text</option>
            <option value="Image">Image</option>
            <option value="Text and Image">Text and Image</option>
            <option value="Shelf (small- under 50 SKUs)">Shelf (small- under 50 SKUs)</option>
            <option value="Shelf (medium 50-100 SKUs)">Shelf (medium 50-100 SKUs)</option>
            <option value="Shelf (large > 100 SKUs)">Shelf (large > 100 SKUs)</option>
          </select>
        </div>
         <!-- checkbox FOR SELECT ALL  -->
         <!-- <div class="col-md-2 checkbox primeTypeAll"> -->
          <div class="col-md-2 text-center">
            <label for="">Set Prime Type for ALL:</label>
            <input type="checkbox" class="center-block" v-model="isAllSelected">
          </div>
          <!-- Prime type FOR SELECT ALL OPTION-->
          <div class="col-md-3" v-show="isAllSelected == true">
            <label for="">Select Prime Type for ALL:</label>
            <select  class="col-md-12" v-model="assetAllType" @change="onAllTypeSelected($event)">
              <option value="" selected disabled>Select Prime Type</option>
              <option value="Assets (Client)">Assets (Client)</option>
              <option value="Assets (Competitors)">Assets (Competitors)</option>
              <option value="Logos (Client, Competitors)">Logos (Client, Competitors)</option>
              <option value="Packages (Current Client, Competitors)">Packages (Current Client, Competitors)</option>
              <option value="Packages (Current Client, Test Packs, Competitors)">Packages (Current Client, Test Packs, Competitors)</option>
              <option value="Packages (Test Pack, Competitors)">Packages (Test Pack, Competitors)</option>
              <option value="Packages (Current Client)">Packages (Current Client)</option>
              <option value="Packages (Competitors)">Packages (Competitors)</option>
              <option value="Packages (Test Pack)">Packages (Test Pack)</option>
              <option value="Debranded Packages (Current Client, Competitors)">Debranded Packages (Current Client, Competitors)</option>
              <option value="Debranded Packages (Test Packs, Competitors)">Debranded Packages (Test Packs, Competitors)</option>
              <option value="Debranded Packages (Current Client)">Debranded Packages (Current Client)</option>
              <option value="Debranded Packages (Test Pack)">Debranded Packages (Test Pack)</option>
              <option value="Debranded Packages (Competitors)">Debranded Packages (Competitors)</option>
              <option value="Category (Different Exemplars)">Category (Different Exemplars)</option>
              <option value="Category (Different Occasions)">Category (Different Occasions)</option>
              <option value="Functional Attributes">Functional Attributes</option>
              <option value="Names">Names</option>
            </select>
          </div>
        <!--  -->
        <div class="assetsHeading">
          <div class="col-md-3">
            <label for="">Prime description</label>
          </div>
          <div class="col-md-4">
            <label for="">Prime URL</label>
          </div>
          <div class="col-md-4">
            <label for="">Prime Type</label>
          </div>
          <div class="col-md-1 text-center">
            <label for="">Delete</label>
          </div>
        </div>

        <div
          class="assetEntries"
          v-for="(asset, index) in brandAssets"
          :key="index"
        >
          <div class="col-md-3">
            <input
              type="text"
              class="col-md-12"
              placeholder="eg: Tide Logo"
              v-model="asset.assetDesc"
            />
          </div>
          <div class="col-md-4">
            <input
              type="text"
              class="col-md-12"
              placeholder="eg: url link for Tide logo"
              v-model="asset.assetURL"
            />
          </div>
          <div class="col-md-4 " >
            <select id="testDisabled" v-model="asset.assetPrimeType" class="col-md-12" :disabled="isAllSelected" >
              <option value="" selected disabled>Select Prime Type</option>
              <option value="Assets (Client)">Assets (Client)</option>
              <option value="Assets (Competitors)">Assets (Competitors)</option>
              <option value="Logos (Client, Competitors)">Logos (Client, Competitors)</option>
              <option value="Packages (Current Client, Competitors)">Packages (Current Client, Competitors)</option>
              <option value="Packages (Current Client, Test Packs, Competitors)">Packages (Current Client, Test Packs, Competitors)</option>
              <option value="Packages (Test Pack, Competitors)">Packages (Test Pack, Competitors)</option>
              <option value="Packages (Current Client)">Packages (Current Client)</option>
              <option value="Packages (Competitors)">Packages (Competitors)</option>
              <option value="Packages (Test Pack)">Packages (Test Pack)</option>
              <option value="Debranded Packages (Current Client, Competitors)">Debranded Packages (Current Client, Competitors)</option>
              <option value="Debranded Packages (Test Packs, Competitors)">Debranded Packages (Test Packs, Competitors)</option>
              <option value="Debranded Packages (Current Client)">Debranded Packages (Current Client)</option>
              <option value="Debranded Packages (Test Pack)">Debranded Packages (Test Pack)</option>
              <option value="Debranded Packages (Competitors)">Debranded Packages (Competitors)</option>
              <option value="Category (Different Exemplars)">Category (Different Exemplars)</option>
              <option value="Category (Different Occasions)">Category (Different Occasions)</option>
              <option value="Functional Attributes">Functional Attributes</option>
              <option value="Names">Names</option>
            </select>

          </div>
          <div class="col-md-1 text-center">
            <button
              type="button"
              class="btn btn-xs btn-warning"
              :class="{'hide-on-preview':generalObj.IsLocked}"
              @click="deletePrime(asset.assetID, index)"
            >
              x
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Attributes configure panel -->
    <div class="panel panel-info configurePanel"   :class="{'configurePanel--preview':generalObj.IsLocked}">
      <div class="panel-heading">
        <h3 class="panel-title">
          Associate Target (i.e. personality or emotional dimensions)
        </h3>
        <!-- <div class="btnContainer">
          <button class="btn btn-primary btn-sm" :class="{'hide-on-preview':generalObj.IsLocked}" @click="addMoreCategoryAssets()">
            Add Attribute
          </button>
        </div> -->
      </div>

      <div class="panel-body">
        <div
          class="col-md-6 category1"
          v-for="(category, i) in categoryAssets"
          :key="i"
        >
          <label for="">Category Name</label>
          <input
            type="text"
            class="col-md-12"
            placeholder="eg: INSPIRATIONAL"
            v-model="category.categoryName"
          />

          <label for="">Category Definition</label>
          <textarea
            rows="3"
            class="col-md-12"
            placeholder="eg: standing out, being unique, new, and thinking outside the box. Please put the content after word 'means'."
            v-model="category.categoryDesc"
          ></textarea>

          <label for="" class="attribute">Attribute Options</label>
          <button class="btn btn-primary btn-sm btn-attribute" :class="{'hide-on-preview':generalObj.IsLocked}" @click="addMoreCategoryAssets(i)">Add Attribute</button>
          <div
            class="attributeInput row"
            v-for="(attr, index) in category.assets"
            :key="index"
          >

            <div class="col-md-2">
              <select v-model="attr.assetZone" :id="`selectedZone_${i}_${index}`" class="col-md-12" @change="onZoneSelected(i, index)">
                <option value="" selected disabled>Select Zone</option>
                <option data-zoneid="1" value="Interesting" >Interesting</option>
                <option data-zoneid="2" value="Fun" >Fun</option>
                <option data-zoneid="3" value="Friendly" >Friendly</option>
                <option data-zoneid="4" value="Nurturing" >Nurturing</option>
                <option data-zoneid="5" value="Familiar" >Familiar</option>
                <option data-zoneid="6" value="Trustworthy" >Trustworthy</option>
                <option data-zoneid="7" value="Knowledgeable" >Knowledgeable</option>
                <option data-zoneid="8" value="Inspiring" >Inspiring</option>
              </select>
            </div>

            <div class="col-md-2">
              <select v-model="attr.assetRing" :id="`selectedRing_${i}_${index}`" class="col-md-12"  @change="onRingSelected(i, index)" >
                <option value="" selected disabled>Select Ring</option>
                <option data-ringid="1" value="Core" >Core</option>
                <option data-ringid="2" value="Differentiator" >Differentiator</option>
                <option data-ringid="3" value="Cusp" >Cusp</option>
                <option data-ringid="4" value="Negative" >Negative</option>
              </select>
            </div>

            <div class="col-md-3">
              <select  v-model="attr.assetDesc" name="attributeOption" :id="`selectedAttribute_${i}_${index}`" class="col-md-12"  @focus="getAttributeOptions(i, index);">
                <option value="" selected disabled>Select Attribute</option>
                <option value="Add New">-- ADD NEW --</option>
                <option :value="`${attr.assetDesc}`" selected disabled>{{attr.assetDesc}}</option>
                <!-- populated with js -->
              </select>
            </div>

           <div class="col-md-4"  v-if="attr.assetDesc === 'Add New'">
              <input type="text" class="col-md-12" v-model.trim="attr.assetDescOther" :id="`selectedOther_${i}_${index}`"  placeholder="Please enter new attribute"/>
           </div>

            <div class="col-md-1 text-right">
              <button
                type="button"
                class="btn btn-xs btn-warning"
                :class="{'hide-on-preview':generalObj.IsLocked}"
                @click="deleteCateAsset(attr.assetID, index, category.assets)"
              >
                x
              </button>
            </div>
          </div>
          <hr/>
        </div>
      </div>
    </div>
    <!-- Edit fields - Confirmation Modal -->
    <div
      class="modal modal--confirmation fade"
      style="display: block"
      :class="{ in: showConfirmationModal }"
      v-if="showConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmationModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              @click="showConfirmationModal = false"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              &times;
            </button>
            <h4 class="modal-title" id="confirmationModalLabel">
              {{ modalTitle }}
            </h4>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to change this field? Please make sure you consult the BSA team first.</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showConfirmationModal = false"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="confirmFieldEdit"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-backdrop fade"
      :class="{ in: showConfirmationModal }"
      v-show="showConfirmationModal"
      @click="showConfirmationModal = false"
    ></div>

    <!-- Double prime - Confirmation Modal -->
    <!-- <modal
      text="Are you sure you want to double prime? This will double the survey experience. If you have questions, ask the BSA team."
      title="Double Prime Impression"
      :toggleModal="showDoublePrimeModal"
      @confirm="generalObj.testBrand = true, showDoublePrimeModal = false"
      @close="showDoublePrimeModal = false" >
     </modal> -->
     <div
     class="modal modal--confirmation fade"
     style="display: block"
     :class="{ in: showDoublePrimeModal }"
     v-if="showDoublePrimeModal"
     tabindex="-1"
     role="dialog"
     aria-labelledby="confirmationModalLabel"
     aria-hidden="true"
   >
     <div class="modal-dialog">
       <div class="modal-content">
         <div class="modal-header">
           <button
             type="button"
             @click="showDoublePrimeModal = false"
             class="close"
             data-dismiss="modal"
             aria-hidden="true"
           >
             &times;
           </button>
           <h4 class="modal-title" id="confirmationModalLabel">
             Double Prime Impression
           </h4>
         </div>
         <div class="modal-body">
           <p>
             Are you sure you want to double prime? This will double the survey
             experience. If you have questions, ask the BSA team.
           </p>
         </div>
         <div class="modal-footer">
           <button
             type="button"
             class="btn btn-default"
             data-dismiss="modal"
             @click="showDoublePrimeModal = false"
           >
             No
           </button>
           <button
             type="button"
             class="btn btn-primary"
             @click="
               (generalObj.testBrand = true), (showDoublePrimeModal = false)
             "
           >
             Yes
           </button>
         </div>
       </div>
     </div>
   </div>
   <div
     class="modal-backdrop fade"
     :class="{ in: showDoublePrimeModal }"
     v-show="showDoublePrimeModal"
     @click="showDoublePrimeModal = false"
   ></div>
<!-- END Modal -->

  </div>
</template>

<script>
import { eventBus } from "../../main.js";
import * as utils from "../../utils.js";
// import Modal from '../general/Modal.vue';

export default {
  // components: {
  //     modal: Modal
  // },
  data() {
    return {
      createMode: true,
      adminID: 64,
      projectID: 0,
      cipID: 0,
      generalObj: {
        projectName: "",
        exerciseType: "",
        testBrand: false,
        primeDuration: 700,
        testDuration: 1000,
        feedbackDuration: 350,
        blankInterval: 200,
        language: "",
      },
      languages: [
        "Afrikaans",
        "Bulgarian",
        "Chinese-Simplified",
        "Czech",
        "Dutch",
        "English",
        "French",
        "German",
        "Hindi",
        "Hungarian",
        "Italian",
        "Japanese",
        "Kazakh",
        "Norwegian",
        "Polish",
        "Portuguese",
        "Romanian",
        "Russian",
        "Serbian-Latin",
        "Spainish-Spain",
        "Spainish-Mexico",
        "Swedish",
        "Thai",
        "Turkish",
        "Xhosa",
        "Zulu"
      ],
      principle: {
        clientURL: "POSITIVE",
        clientDesc: "Good",
        competitiveURL: "NEGATIVE",
        competitiveDesc: "Bad",
      },
      noCateDefined: false,
      counter: 0,
      brandAssets: [],
      categoryAssets: [],
      generalObjOrg: "",
      principleOrg: "",
      brandAssetsOrg: "",
      primeAssignmentOrg: "",
      preExposureFormatTypeOrg: "",
      categoryAssetsOrg: "",
      isGeneralValidated: true,
      isBrandValidated: true,
      isPrimeAssignmentValidated: true,
      isPreExposureValidated: true,
      isCategoryValidated: true,
      isPrincipleValidated: true,
      appBlockElm: document.getElementById("appBlock"),
      appContainer: document.getElementById("appContainer"),
      wsHeader: "https://iat.hotspexeurope.com/service.asmx/",
      editableFieldsControl: {
        primeDuration: false,
        testDuration: false,
        feedbackDuration: false,
        blankInterval: false,
      },
      showConfirmationModal: false,
      modalTitle: null,
      editableFieldName: null,
      showDoublePrimeModal: false,
      primeAssignment: "",
      preExposureFormatType: "",
      isAllSelected: false,
      assetAllType: "",
      assetDescOther: ""
    };
  },
  computed: {
    sortedLanguages() {
      return this.languages.slice().sort();
      }
  },
  methods: {
    saveProject() {
      if (this.projectID === 0) {
        this.createNewProject();
      } else {
        this.updateProject();
      }
    },
    generalValidate() {
      if (
        this.generalObj.projectName !== "" &&
        this.generalObj.testBrand !== "" &&
        this.generalObj.primeDuration !== "" &&
        this.generalObj.testDuration !== "" &&
        this.generalObj.feedbackDuration !== "" &&
        this.generalObj.blankInterval !== "" &&
        this.generalObj.exerciseType !== "" &&
        this.generalObj.language !== ""
      ) {
        this.isGeneralValidated = true;
      } else {
        this.isGeneralValidated = false;
      }

      return this.isGeneralValidated;
    },
    principleValidate() {
      if (
        this.principle.clientURL !== "" &&
        this.principle.clientDesc !== "" &&
        this.principle.competitiveDesc !== "" &&
        this.principle.competitiveURL !== ""
      ) {
        this.isPrincipleValidated = true;
      } else {
        this.isPrincipleValidated = false;
      }

      return this.isPrincipleValidated;
    },
    brandValidate() {
      let tempBrandAssets = [];
      tempBrandAssets = this.brandAssets.filter((brand) => {
        return brand.assetURL && brand.assetDesc && brand.assetPrimeType;
      });

      if (tempBrandAssets.length > 0) {
        this.brandAssets = tempBrandAssets;
        this.isBrandValidated = true;
      } else {
        this.isBrandValidated = false;
      }
      return this.isBrandValidated;
    },
    primeAssignemntValidate() {
       if (this.primeAssignment !== "") {
        this.isPrimeAssignmentValidated =true;
      } else {
        this.isPrimeAssignmentValidated = false;
      }
    },
    primePreExposureValidate() {
       if (this.preExposureFormatType !== "") {
        this.isPreExposureValidated = true;
      } else {
        this.isPreExposureValidated = false;
      }
    },
    categoryValidate() {
        let tempCategoryAssets = [];

        tempCategoryAssets = this.categoryAssets.filter((category) => {
          return category.categoryName && category.categoryDesc && category.assets;
        });

        this.isCategoryValidated = false;

        for (var i = 0; i < tempCategoryAssets.length; i++) {
          if (tempCategoryAssets[i].categoryName == "" ||
            tempCategoryAssets[i].categoryDesc == "" ||
            tempCategoryAssets[i].assets.length < 2) {
              this.isCategoryValidated = false;
              break;
          }

          for (var assetIndex = 0; assetIndex < tempCategoryAssets[i].assets.length; assetIndex++) {
            if (tempCategoryAssets[i].assets[assetIndex].assetDesc == "" || tempCategoryAssets[i].assets[assetIndex].assetZone == "" || tempCategoryAssets[i].assets[assetIndex].assetRing == "") {
              this.isCategoryValidated = false;
              break;
            } else {
              if(tempCategoryAssets[i].assets[assetIndex].assetDesc == "Add New" && tempCategoryAssets[i].assets[assetIndex].assetDescOther == ""){
                this.isCategoryValidated = false;
                break;
              } else if((tempCategoryAssets[i].assets[assetIndex].assetDesc == "Add New") && !(tempCategoryAssets[i].assets[assetIndex].assetDescOther == "")){
                this.isCategoryValidated = true;
              }
              this.isCategoryValidated = true;
            }
          }
        }

      return this.isCategoryValidated;
    },
    generateErrorMessage() {
      // console.log('this.isGeneralValidated: ' + this.isGeneralValidated);
      // console.log('this.isBrandValidated: ' + this.isBrandValidated);
      // console.log('this.isPrincipleValidated: ' + this.isPrincipleValidated);
      console.log('this.isCategoryValidated: ' + this.isCategoryValidated);

      let content = "Please make sure you: \n\r";

      if (!this.isGeneralValidated) {
        content += '-- fill all the field in "General Configure".\n';
      }

      if (!this.isBrandValidated) {
        content +=
          "-- fill description, URL and Type for every Prime entry.\n";
      }
      if (!this.isPrimeAssignmentValidated) {
        content +=
          "-- fill Prime Assignemnt.\n";
      }
      if(!this.isPreExposureValidated) {
        content +=
          "-- fill Pre-exposure Format Type.\n";
      }
      if (!this.isPrincipleValidated) {
        content += '-- fill all the field in "Principal Target".\n';
      }

      if (!this.isCategoryValidated) {
        content +=
          "-- fill the category name and definition for both categories and make sure provide at least two attributes, Zone name and Ring name for each category\n";
      }

      window.alert(content);
    },
    deleteCateAsset(assetID, index, assets) {
      if (assetID && assetID !== 0) {
        // the asset doesn't existed in the DB yet
        console.log("remove category asset from DB");
        this.$http
          .post(
            this.wsHeader + "deleteCategoryDetails",
            JSON.stringify({ assetID: assetID })
          )
          .then((response) => response.json())
          .then((data) => {
            if (data) {
              console.log(
                "deleteCategoryDetails - data: " + JSON.stringify(data)
              );
              assets.splice(index, 1);
            }
          });
      } else {
        assets.splice(index, 1);
      }
    },
    deletePrime(assetID, index) {
      console.log("assetID: " + assetID);

      if (assetID && assetID !== 0) {
        console.log("remove asset from DB");
        this.$http
          .post(
            this.wsHeader + "DeletePGNATasset",
            JSON.stringify({ assetIDs: assetID.toString() })
          )
          .then((response) => response.json())
          .then((data) => {
            if (data) {
              console.log("DeletePGNATasset - data: " + JSON.stringify(data));
              this.brandAssets.splice(index, 1);
            }
          });
      } else {
        this.brandAssets.splice(index, 1);
      }
    },
    createNewProject() {
      this.counter = 0;

      this.generalValidate();
      this.brandValidate();
      this.categoryValidate();
      this.principleValidate();
      this.primeAssignemntValidate();
      this.primePreExposureValidate();

      if (
        this.isGeneralValidated &&
        this.isBrandValidated &&
        this.isPrincipleValidated &&
        this.isCategoryValidated && this.isPrimeAssignmentValidated && this.isPreExposureValidated
      ) {
        console.log(
          "PROJECT IS VALIDED FOR SAVE - LET US GET PROJECT ID FIRST"
        );
        this.addLoadingBlock();
        this.getProjectID();
      } else {
        this.generateErrorMessage();
      }
    },
    getProjectID() {
      var userData = JSON.parse(JSON.stringify(this.generalObj));
      userData.cipID = this.cipID;
      userData.projectType = 3;
      userData.updateBy = this.adminID;

      this.$http
        .post(
          this.wsHeader + "createImplicitProject",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            // console.log("createImplicitProject - data: " + JSON.stringify(data));
            this.projectID = data.d.projectID;

            this.counter++;

            this.addImplicitCate();

            this.addPgnatPrinciple();
            this.updatePgnatAsset();
          }
        });
    },
    addPgnatPrinciple() {
      var userData = JSON.parse(JSON.stringify(this.principle));
      userData.projectID = this.projectID;

      this.$http
        .post(
          this.wsHeader + "addPgnatPrinciple",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log("addPgnatPrinciple - data: " + JSON.stringify(data));

            this.counter++;

            if (this.counter === 5) {
              this.removeLoadingBlock();
            }
          }
        });
    },
    addImplicitCate() {

      var userData = {
        projectID: this.projectID,
        updateBy: this.adminID,
        cates: [
          {
            categoryName: this.categoryAssets[0].categoryName,
            categoryDesc: this.categoryAssets[0].categoryDesc,
          },
          {
            categoryName: this.categoryAssets[1].categoryName,
            categoryDesc: this.categoryAssets[1].categoryDesc,
          },
        ],
      };

      this.$http
        .post(
          this.wsHeader + "addImplicitCate",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            this.counter++;

            console.log("addImplicitCate success - data: " + JSON.stringify(data));

            this.categoryAssets[0].categoryID = data.d.cates[0].categoryID;
            this.categoryAssets[1].categoryID = data.d.cates[1].categoryID;

            this.addImplicitCateDetail();
          }
        });
    },
    addImplicitCateDetail() {
      this.passOtherValueOver();

      var userData = {
        categoryAssets: [
          {
            categoryID: this.categoryAssets[0].categoryID,
            assets: this.categoryAssets[0].assets,
          },
          {
            categoryID: this.categoryAssets[1].categoryID,
            assets: this.categoryAssets[1].assets,
          },
        ],
      };
      // console.log("Try to addImplicitCateDetail - userData: " + JSON.stringify(userData));

      this.$http
        .post(
          this.wsHeader + "addImplicitCateDetail",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            // console.log("addImplicitCateDetail success - data: " + JSON.stringify(data));

            this.categoryAssets[0].assets = data.d.categoryAssets[0].assets;
            this.categoryAssets[1].assets = data.d.categoryAssets[1].assets;

            this.counter++;

            if (this.counter === 5) {
              this.removeLoadingBlock();
            }
            this.getExistedProject();
          }
        });
    },
    updateProject() {
      let isGeneralObjChanged = true,
        isPrincipleChanged = true,
        isBrandAssetsChanged = true,
        isCategoryAssetsChanged = true,
        isAssignemtPreExposrueChanged = true,
        isPreExposureChanged = true;

      if (this.generalObjOrg === JSON.stringify(this.generalObj)) {
        // not change on generalObj
        this.counter++;
        this.isGeneralValidated = true;

        isGeneralObjChanged = false;
      } else {
        this.generalValidate();
      }

      if (this.principleOrg === JSON.stringify(this.principle)) {
        // not change on principle
        this.counter++;
        this.isPrincipleValidated = true;

        isPrincipleChanged = false;
      } else {
        this.principleValidate();
      }

      if (this.brandAssetsOrg === JSON.stringify(this.brandAssets)) {
        // not change on brandAssets
        this.counter++;
        this.isBrandValidated = true;

        isBrandAssetsChanged = false;
      } else {
        this.brandValidate();
      }
      if(this.primeAssignmentOrg === JSON.stringify(this.primeAssignment) ){
        isAssignemtPreExposrueChanged = false;
        this.isPrimeAssignmentValidated = true;
      } else {
        this.primeAssignemntValidate();
      }
      if(this.preExposureFormatTypeOrg === JSON.stringify(this.preExposureFormatType)) {
        isPreExposureChanged = false;
        this.isPreExposureValidated = true;
      } else {
        this.primePreExposureValidate();
      }
      if (this.categoryAssetsOrg === JSON.stringify(this.categoryAssets)) {
        // not change on categoryAssets
        this.counter++;
        this.isCategoryValidated = true;

        isCategoryAssetsChanged = false;
      } else {
        this.categoryValidate();
      }

      if (
        this.isGeneralValidated &&
        this.isBrandValidated &&
        this.isPrincipleValidated &&
        this.isCategoryValidated && this.isPrimeAssignmentValidated && this.isPreExposureValidated
      ) {
        if (isGeneralObjChanged) {
          this.updateImplictProject();
        }

        if (isCategoryAssetsChanged) {
          if (this.noCateDefined) {
            this.addImplicitCate();
          } else {
            // this.addImplicitCate();
            this.updateImplicitCate();
          }
        }

        if (isPrincipleChanged) {
          this.updatePgnatPrinciple();
          // this.addPgnatPrinciple();
        }

        if (isBrandAssetsChanged) {
          this.updatePgnatAsset();
        }

        if (isAssignemtPreExposrueChanged) {
          this.updatePgnatAsset();
        }

        if(isPreExposureChanged) {
          this.updatePgnatAsset();
        }

      } else {
        this.generateErrorMessage();
      }
    },
    updateImplictProject() {
      var userData = JSON.parse(JSON.stringify(this.generalObj));
      userData.projectID = this.projectID;
      userData.projectType = 3;
      userData.updateBy = this.adminID;

      this.$http
        .post(
          this.wsHeader + "updateImplicitProject",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log("updateImplicitProject - data: " + JSON.stringify(data));

            this.counter++;

            if (this.counter === 5) {
              this.removeLoadingBlock();
            }
          }
        });
    },
    updateImplicitCate() {
      this.passOtherValueOver();

      var userData = {};
      userData.updateBy = this.adminID;
      userData.projectID = this.projectID;
      userData.categoryAssets = JSON.parse(JSON.stringify(this.categoryAssets));

    //   console.log("updateImplicitCate - userData: " + JSON.stringify(userData));

      this.$http
        .post(
          this.wsHeader + "updateImplicitCate",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            // console.log("updateImplicitCate - data: " + JSON.stringify(data));

            this.counter = this.counter + 2;

            if (this.counter === 5) {
              this.removeLoadingBlock();
            }
            this.getExistedProject();
          }
        });
    },
    updatePgnatAsset() {
      var userData = {
        projectID: this.projectID,
        updateBy: this.adminID,
        assets: this.brandAssets,
        primeAssignment: this.primeAssignment,
        preExposureFormatType: this.preExposureFormatType,
      };

      this.$http
        .post(
          this.wsHeader + "updatePgnatAsset",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log("updatePgnatAsset - data: " + JSON.stringify(data));

            // we need to reassign brandAssets to get updated assetID
            this.brandAssets = data.d.assets;

            this.counter++;

            if (this.counter === 5) {
              this.removeLoadingBlock();
            }
          }
        });
    },
    updatePgnatPrinciple() {
      var userData = JSON.parse(JSON.stringify(this.principle));
      userData.projectID = this.projectID;
      userData.updateBy = this.adminID;

      console.log("updatePgnatPrinciple: " + JSON.stringify(userData));

      this.$http
        .post(
          this.wsHeader + "updatePgnatPrinciple",
          JSON.stringify({ userdata: userData })
        )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log("updatePgnatPrinciple success - data: " + JSON.stringify(data));
            // no get to update principle since they are primative data.

            this.counter++;

            if (this.counter === 5) {
              this.removeLoadingBlock();
            }
          }
        });
    },
    testProject() {
      let testURL =
        "https://apps.hotspexeurope.com/ext/mob/packspex/apt/index.html?projectID=" +
        this.projectID;
      window.open(testURL, "_blank");
    },
    resetFields() {
      this.generalObj = {
        projectName: "",
        exerciseType: "",
        testBrand: false,
        primeDuration: 700,
        testDuration: 1000,
        feedbackDuration: 350,
        blankInterval: 200,
        language: "",
      };
      this.principle = {
        clientURL: "POSITIVE",
        clientDesc: "Good",
        competitiveURL: "NEGATIVE",
        competitiveDesc: "Bad",
      };
      this.primeAssignment = "",
      this.preExposureFormatType = "",
      this.brandAssets = [];
      this.categoryAssets = [];
      this.projectID = 0;
      this.cipID = 0;
      this.isGeneralValidated = true;
      this.isBrandValidated = true;
      this.isCategoryValidated = true;
      this.isPrincipleValidated = true;
      this.generalObjOrg = "";
      this.principleOrg = "";
      this.brandAssetsOrg = "";
      this.categoryAssetsOrg = "";
      this.noCateDefined = false;
      this.editableFieldsControl = {
        primeDuration: false,
        testDuration: false,
        feedbackDuration: false,
        blankInterval: false,
      };
      this.showConfirmationModal = false;
      this.modalTitl = null;
      this.editableFildName = null;
      this.isAllSelected = false;
      this.isPrimeAssignmentValidated = true;
      this.isPreExposureValidated = true;
      this.primeAssignmentOrg = "";
      this.preExposureFormatTypeOrg = "";
      this.assetDescOther = "";
    },
    addLoadingBlock() {
      this.appBlockElm.classList.remove("hidden");
    },
    removeLoadingBlock() {
      this.appBlockElm.classList.add("hidden");
    },
    addMoreAssets() {
      if (this.isAllSelected &&  this.assetAllType !== "") {
        this.brandAssets.push({ assetDesc: "", assetURL: "", id: 0, assetPrimeType: this.assetAllType });
      } else {
        this.brandAssets.push({ assetDesc: "", assetURL: "", id: 0, assetPrimeType: "" });
      }
    },
    addMoreCategoryAssets(index) {
      this.categoryAssets[index].assets.push({ assetID: 0, assetDesc: "", assetRing: "", assetZone:"", assetDescOther: "" });
    },
    exportBrandMap() {
      this.addLoadingBlock();

      var exportMapping = "";
      this.brandAssets.forEach((brand) => {
        if (brand.assetURL && brand.assetDesc) {
          exportMapping +=
            "id: " +
            brand.id +
            "\tassetURL: " +
            brand.assetURL +
            "\tassetDesc: " +
            brand.assetDesc +
            "\r\n";
        }
      });

      utils.copyTextToClipboard(exportMapping);

      var self = this;
      setTimeout(function () {
        alert(
          "The brand map has been copied to your clipboard. Use ctrl + v to paste it to your excel."
        );

        self.removeLoadingBlock();
      }, 200);
    },
    async getUserCookie() {
      var response = await utils.readCookie("HOTSPEXAWESOME");

      if((response && response.success)) {
        let hsCookie = response.data;
        if (hsCookie && hsCookie !== "" && hsCookie !== null) {
          hsCookie = utils.queryStringToJSON(hsCookie);
          this.adminID = hsCookie.adminID;
        } else {
          if (window.location.href.indexOf("http://localhost:8008") !== -1) {
            this.adminID = 64;
          } else {
            alert(
              "Please log in https://awesome.hotspexeurope.com/ site first before continue"
            );
          }
        }
      } else {
        setTimeout(function () {
          alert(response.message)
          window.open('https://awesome.hotspexeurope.com/', '_self')
        })
      }
    },
    populateNewProject() {
      for (var i = 0; i < 10; i++) {
        this.brandAssets.push({ assetDesc: "", assetURL: "", assetID: 0, assetPrimeType: ""});
      }

      this.categoryAssets = [
        {
          categoryName: "",
          categoryDesc: "",
          assets: [],
        },
        {
          categoryName: "",
          categoryDesc: "",
          assets: [],
        },
      ];

      for (i = 0; i < 10; i++) {
        if (i < 5) {
          this.categoryAssets[0].assets.push({ assetDesc: "", assetID: 0, assetRing: "", assetZone:"", assetDescOther: ""  });
        } else {
          this.categoryAssets[1].assets.push({ assetDesc: "", assetID: 0, assetRing: "", assetZone:"", assetDescOther: "" });
        }
      }
    },
    getExistedProject() {
      this.addLoadingBlock();

      this.$http
        .post(this.wsHeader + "getPgnatProject", { projectID: this.projectID })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            console.log("getPgnatProject - data: " + JSON.stringify(data));

            this.generalObj = data.generalObj;

            this.generalObj.testBrand =
              this.generalObj.testBrand.toString() === "False" ? false : true;

            this.primeAssignment = data.primeAssignment;
            this.preExposureFormatType = data.preExposureFormatType;

            if (data.principle !== null) {
              this.principle = data.principle;
              console.log("we should be here");
            }

            if (data.brandAssets === null || data.brandAssets.length === 0) {
              for (var i = 0; i < 10; i++) {
                this.brandAssets.push({
                  assetDesc: "",
                  assetURL: "",
                  assetID: 0,
                  assetPrimeType: "",
                });
              }
            } else {
              this.brandAssets = data.brandAssets;
            }

            if (
              data.categoryAssets === null ||
              data.categoryAssets.length === 0
            ) {
              this.categoryAssets = [
                {
                  categoryName: "",
                  categoryDesc: "",
                  assets: [],
                },
                {
                  categoryName: "",
                  categoryDesc: "",
                  assets: [],
                },
              ];

              this.noCateDefined = true;
            } else {
              this.categoryAssets = data.categoryAssets;
              for (var i = 0; i< this.categoryAssets.length; i++){
                for (var assetIndex = 0; assetIndex < this.categoryAssets[i].assets.length; assetIndex++) {
                  if (this.categoryAssets[i].assets[assetIndex].assetDesc === this.categoryAssets[i].assets[assetIndex].assetDescOther) {
                    this.categoryAssets[i].assets[assetIndex].assetDesc = "Add New"
                  }
                }
              }

              this.noCateDefined = false;
              // console.log("load category: " + JSON.stringify(this.categoryAssets));
            }

            this.generalObjOrg = JSON.stringify(this.generalObj);
            this.principleOrg = JSON.stringify(this.principle);
            this.brandAssetsOrg = JSON.stringify(this.brandAssets);
            this.categoryAssetsOrg = JSON.stringify(this.categoryAssets);
            this.primeAssignmentOrg = JSON.stringify(this.primeAssignment);
            this.preExposureFormatTypeOrg = JSON.stringify(this.preExposureFormatType);

            this.removeLoadingBlock();
          }
        });
    },
    openConfirmationModal(title, name) {
      this.modalTitle = title;
      this.editableFieldName = name;
      this.showConfirmationModal = true;
    },
    confirmFieldEdit() {
      this.editableFieldsControl[this.editableFieldName] = true;
      this.showConfirmationModal = false;
    },
    toggleDoubleTime(e){
      if(this.generalObj.testBrand === false){
        e.preventDefault();
      }
      this.generalObj.testBrand === false ? this.showDoublePrimeModal=true : this.showDoublePrimeModal=false
    },
    onAllTypeSelected() {
      if (this.isAllSelected &&  this.assetAllType !== "") {
        for (var i = 0; i < this.brandAssets.length; i++) {
          this.brandAssets[i] =  {
            "assetDesc": this.brandAssets[i].assetDesc,
            "assetURL": this.brandAssets[i].assetURL,
            "assetID": this.brandAssets[i].assetID,
            "assetPrimeType": this.assetAllType,
         };
        }
      }
    },
     onZoneSelected (categoryIndex, attributeIndex) {
      this.getAttributeOptions(categoryIndex, attributeIndex);
    },
    onRingSelected (categoryIndex, attributeIndex) {
      this.getAttributeOptions(categoryIndex, attributeIndex);
    },
    getAttributeOptions (categoryIndex, attributeIndex){
      let zoneDropdown = document.getElementById(`selectedZone_${categoryIndex}_${attributeIndex}`)
      let ringDropdown = document.getElementById(`selectedRing_${categoryIndex}_${attributeIndex}`)

      var zoneID = zoneDropdown.selectedOptions[0].dataset.zoneid;
      var ringID = ringDropdown.selectedOptions[0].dataset.ringid;

        if (!(zoneID == "" || zoneID == 0 || zoneID == undefined || ringID == "" || ringID == 0 || ringID == undefined)){
        this.$http
          .post(this.wsHeader + "GetAttributesAutofill", { languageid: 1, zoneID: zoneID, ringID: ringID})
          .then((response) => response.json())
          .then((data) => {
            if (data) {
              console.log("GetAttributesAutofill - data: " + JSON.stringify(data));

              let attributeDropdown = document.getElementById(`selectedAttribute_${categoryIndex}_${attributeIndex}`)

              attributeDropdown.innerHTML = '<option value="" selected disabled>Select Attribute</option>';
              for (let i = 0; i < data.length; i++) {
                // attributeDropdown.innerHTML = attributeDropdown.innerHTML +
                //   '<option id="' + data[i]['AttributeID'] + '">' + data[i]['AttributeLabel'] + '</option>';
                attributeDropdown.innerHTML = attributeDropdown.innerHTML +
                  '<option id="' + data[i]['AttributeID'] + '" disabled class="text-primary text-uppercase font-weight-bold">' + '--'+ data[i]['AttributeLabel'] + '--' + '</option>';
                  if (!(data[i].AttributeSynonym === null || data[i].AttributeSynonym.length == 0)){
                    for (var a=0; a < data[i].AttributeSynonym.length; a++){
                      attributeDropdown.innerHTML = attributeDropdown.innerHTML + '<option value="' + data[i].AttributeSynonym[a].synonymLabel + '" >' + data[i].AttributeSynonym[a].synonymLabel + '</option>';
                    }
                  }
              }

            attributeDropdown.innerHTML = attributeDropdown.innerHTML + '<option value="Add New">-- ADD NEW --</option>';
          }
        });
      }
    },
    passOtherValueOver(){
      let tempCategoryAssets = [];

        tempCategoryAssets = this.categoryAssets.filter((category) => {
          return category.categoryName && category.categoryDesc && category.assets;
        });

      for (var i = 0; i < tempCategoryAssets.length; i++) {
          for (var assetIndex = 0; assetIndex < tempCategoryAssets[i].assets.length; assetIndex++) {
              if((this.isCategoryValidated) && (tempCategoryAssets[i].assets[assetIndex].assetDesc == "Add New") && !(tempCategoryAssets[i].assets[assetIndex].assetDescOther == "")){
                 tempCategoryAssets[i].assets[assetIndex].assetDesc = tempCategoryAssets[i].assets[assetIndex].assetDescOther
              } else if((this.isCategoryValidated) && !(tempCategoryAssets[i].assets[assetIndex].assetDesc == "Add New") && !(tempCategoryAssets[i].assets[assetIndex].assetDescOther == "")){
                tempCategoryAssets[i].assets[assetIndex].assetDescOther = '';
              }
          }
        }
    },
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave - save and back");

    eventBus.$emit("updateProjectList");

    // reset the value before leaving
    this.resetFields();
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      vm.projectID = vm.$route.query.projectID ? vm.$route.query.projectID : 0;
      vm.cipID = vm.$route.query.cipID;

      if (vm.projectID === 0) {
        console.log("populate new project");
        vm.populateNewProject();
      } else {
        console.log("populate existing project");
        vm.getExistedProject();
      }

      await vm.getUserCookie();
    });
  },
};
</script>

<style lang="scss" scoped>
h3 {
  display: inline-block;
}

.btnExplaination {
  margin-bottom: 10px;
}

.btnExplaination p {
  margin-top: 8px;
}

.btnContainer {
  float: right;
  margin-top: -5px;
}

.btnContainer .btn-sm {
  width: 150px;
}

.btn{
  &.hide-on-preview{
    display: none;
  }
}

.primeDouble {
  padding: 10px 20px;
  background-color: #eee;
  margin-top: -15px;
}

.assetEntries .btn-xs {
  padding: 1px 7px;
  font-size: 14px;
  font-weight: 700;
}

.navbar-text {
  color: #fff;
  font-weight: 400;
}

.configurePanel {
  opacity: 1;
  label,input{
    display: block;
    clear: both;
  }
  .attribute{
    display: inline-block;
    margin-bottom: 16px;
  }
  .btn-attribute{
    float: right;
  }
  small{
    margin-bottom: 10px;
    color: #337ab7;
  }
  input, textarea, select{
    margin-bottom: 10px;
  }
   select {
    width: 100%;
    height: 26px;
  }
  .primeTypeAll{
    padding: 10px 20px;
  }
  .primeTypeAll label{
    font-weight: bold;
  }
  &--preview{
    input[type=text], textarea, select{
      border: 0;
      padding: 0;
      pointer-events: none;
      background: transparent;
    }
    .edit-field-icon, .hide-on-preview{
      display: none;
    }
    .checkbox{
      pointer-events: none;
    }
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
    }

  }
}

textarea {
  resize: none;
  color: #337ab7;
}

input[type="text"] {
  color: #337ab7;
}

.glyphicon {
  font-size: 24px;
  color: #337ab7;
  cursor: pointer;
}

.glyphicon:hover {
  color: #a94442;
}

.configurePanel .panel-body {
  padding: 15px 0;
}

.modal {
  &--confirmation {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    right: auto;
    bottom: auto;
  }
  .modal-dialog {
    margin: 25px;
  }
  .modal-content {
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    border: 0;
  }
}

.edit-field-icon {
  display: block;
  width: 16px;
  height: 16px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='494.936' height='494.936' style='enable-background:new 0 0 494.936 494.936' xml:space='preserve'%3E%3Cpath d='M389.844 182.85c-6.743 0-12.21 5.467-12.21 12.21v222.968c0 23.562-19.174 42.735-42.736 42.735H67.157c-23.562 0-42.736-19.174-42.736-42.735V150.285c0-23.562 19.174-42.735 42.736-42.735h267.741c6.743 0 12.21-5.467 12.21-12.21s-5.467-12.21-12.21-12.21H67.157C30.126 83.13 0 113.255 0 150.285v267.743c0 37.029 30.126 67.155 67.157 67.155h267.741c37.03 0 67.156-30.126 67.156-67.155V195.061c0-6.743-5.467-12.211-12.21-12.211z'/%3E%3Cpath d='M483.876 20.791c-14.72-14.72-38.669-14.714-53.377 0L221.352 229.944c-.28.28-3.434 3.559-4.251 5.396l-28.963 65.069a12.203 12.203 0 0 0 2.521 13.6 12.214 12.214 0 0 0 8.639 3.576c1.675 0 3.362-.346 4.96-1.057l65.07-28.963c1.83-.815 5.114-3.97 5.396-4.25L483.876 74.169c7.131-7.131 11.06-16.61 11.06-26.692 0-10.081-3.929-19.562-11.06-26.686zM466.61 56.897 257.457 266.05c-.035.036-.055.078-.089.107l-33.989 15.131L238.51 247.3c.03-.036.071-.055.107-.09L447.765 38.058c5.038-5.039 13.819-5.033 18.846.005a13.205 13.205 0 0 1 3.905 9.414c0 3.559-1.389 6.903-3.906 9.42z'/%3E%3C/svg%3E")
    no-repeat;
  background-size: contain;
  position: absolute;
  right: 12px;
  bottom: 40px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  &.is-disabled {
    opacity: 0.3;
    pointer-events: none;
  }
  &:hover {
    .edit-field-icon__title {
      top: -23px;
      opacity: 1;
    }
  }
  &__title {
    position: absolute;
    top: -20px;
    background: #2c3d4f;
    color: #fff;
    font-size: 11px;
    white-space: nowrap;
    border-radius: 4px;
    padding: 2px 5px;
    text-align: center;
    z-index: 1;
    opacity: 0;
    transition: all 0.2s ease;
    will-change: top;
    pointer-events: none;
  }
}
.center-block {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.assetsHeading {
  clear: both;
}
.attributeInput > div {
  padding-left: 4px;
  padding-right: 4px;
}
.attributeInput {
  margin-left: 0;
  margin-right: 0;
  select, input {
    padding-left: 4px;
    padding-right: 4px;
  }
}
.category1{
  display: inline-block;
  float: none;
}
</style>



// WEBPACK FOOTER //
// APTConfig.vue?90ac341e